import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Toggle } from "kompare-ui-library";
import { Flex, Label, Text } from 'src/components';
import { formatNumber, i18n, mediaQuery } from "src/common";
import { colors } from "src/theme";
import hzzoLogo from "src/assets/images/dopunskoLogo.png";
import { Card } from "./card";

const Logo = styled.img({
  height: '32px',
})

const FlexStyle = styled(Flex)({
  marginBottom: '10px'
})

const CardStyle = styled(Card)({
  padding: '12px',

  [mediaQuery('mobile')]: {
    padding: '20px'
  },
})

interface OfferInfoCardProps {
  companyName?: string;
  price?: string;
  description?: string;
  oneTimeToggle?: boolean;
  priceOneTime?: number;
  priceInstallments: number;
  className?: string;
}

export const OfferInfoCard = ({ companyName = 'HZZO', oneTimeToggle, priceOneTime, priceInstallments, className }: OfferInfoCardProps) => {
  const [isYearToggleChecked, setIsYearToggleChecked] = useState(oneTimeToggle);

  useEffect(() => {
    setIsYearToggleChecked(oneTimeToggle);
  }, [oneTimeToggle]);

  return (
    <CardStyle radius={12} className={className}>
      <FlexStyle gap={8} align='center' justify='space-between'>
        <Text type='large' bold>{companyName}</Text>
        <Logo src={hzzoLogo} alt="logo" />
      </FlexStyle>
      <Flex vertical gap={12}>
        <Flex vertical>
          <Label type='tiny' color={colors.text4}>Informativni pokazatelj</Label>
          <Card radius={8} padding={16} background={colors.background6}>
            <Text type='medium' bold>{`${formatNumber(isYearToggleChecked ? priceOneTime : priceInstallments)}€/${i18n.t(`components.cards.offerHeaderCard.${isYearToggleChecked ? 'yearly' : 'monthly'}`)}`}</Text>
          </Card>
        </Flex>
        <Flex gap={8} justify='space-between'>
          <Text type='small' color={colors.text3}>Ukupna godišnja cijena</Text>
          <Toggle checked={isYearToggleChecked} onChange={() => setIsYearToggleChecked(!isYearToggleChecked)} labelMarginBottom='0px' />
        </Flex>
      </Flex>
    </CardStyle>
  )
};
